import Map from 'ol/Map.js';
import View from 'ol/View.js';
import TileLayer from 'ol/layer/Tile.js';
import {getCenter} from 'ol/extent.js';
import {fromLonLat} from 'ol/proj.js';
import ImageLayer from 'ol/layer/Image.js';
import ImageTile from 'ol/source/ImageTile.js';
import Projection from 'ol/proj/Projection.js';
import Static from 'ol/source/ImageStatic.js';
import OSM from 'ol/source/OSM.js';
import Raster from 'ol/source/Raster.js';
import VectorLayer from 'ol/layer/Vector.js';
import VectorSource from 'ol/source/Vector.js';
import Icon from 'ol/style/Icon.js';
import Style from 'ol/style/Style.js';
import Feature from 'ol/Feature.js';
import Point from 'ol/geom/Point.js';
import GeoJSON from 'ol/format/GeoJSON.js';
import Attribution from 'ol/control/Attribution';
import {defaults as defaultControls} from 'ol/control.js';

let dataRoot = 'data/'
let params = new URLSearchParams(document.location.search);
var txFile = dataRoot + params.get("txfile");
var txQTH = new Array(2);
var txFrequency = 0;
var txERP = 0;
var diagExtent = new Array(4);
var textData;
var transmitter = "";
var diagFile = "";
var ckFile = "";
var diagHeight = 0;
var diagWidth = 0;

var dataGlobal;

const getData = async () => {
  const response = await fetch(txFile);
  const data = await response.json();
  dataGlobal = data;
  return data;
};

(async () => {
  await getData();
  console.log("dataGlobal : " + dataGlobal);
  transmitter = dataGlobal['Transmitter'];
  textData = JSON.stringify(dataGlobal);
  console.log("transmitter : " + transmitter);
  console.log("textdata : " + textData);


txQTH = [dataGlobal.GeoData.Longitude, dataGlobal.GeoData.Latitude];
if (dataGlobal.GeoData.Longitude > 180) {txQTH[0] = -(dataGlobal.GeoData.Longitude - 360)};
txFrequency = dataGlobal.TechData.Frequency;
txERP = dataGlobal.TechData.ERP;
diagFile = dataRoot + dataGlobal.DiagramShape.FileName;
ckFile = dataRoot + dataGlobal.DiagramShape.CkFile;
diagHeight = dataGlobal.DiagramShape.Height;
diagWidth = dataGlobal.DiagramShape.Width;
diagExtent = [dataGlobal.DiagramShape.WestBound, dataGlobal.DiagramShape.SouthBound, dataGlobal.DiagramShape.EastBound, dataGlobal.DiagramShape.NorthBound];

console.log("txQTH : " + txQTH);
console.log("txFrequency : " + txFrequency);
console.log("txERP : " + txERP);
console.log("diagFile : " + diagFile);
console.log("ckFile : " + ckFile);
console.log("diagHeight : " + diagHeight);
console.log("diagWidth : " + diagWidth);
console.log("diagExtent : " + diagExtent);


    function shade(inputs, data) {
      const elevationImage = inputs[0];
      const width = elevationImage.width;
      const height = elevationImage.height;
      const elevationData = elevationImage.data;
      const shadeData = new Uint8ClampedArray(elevationData.length);
      const dp = data.resolution * 2;
      const maxX = width - 1;
      const maxY = height - 1;
      const pixel = [0, 0, 0, 0];
      const twoPi = 2 * Math.PI;
      const halfPi = Math.PI / 2;
      const sunEl = (Math.PI * data.sunEl) / 180;
      const sunAz = (Math.PI * data.sunAz) / 180;
      const cosSunEl = Math.cos(sunEl);
      const sinSunEl = Math.sin(sunEl);
      let pixelX,
        pixelY,
        x0,
        x1,
        y0,
        y1,
        offset,
        z0,
        z1,
        dzdx,
        dzdy,
        slope,
        aspect,
        cosIncidence,
        scaled;
      function calculateElevation(pixel) {
        // The method used to extract elevations from the DEM.
        // In this case the format used is Terrarium
        // red * 256 + green + blue / 256 - 32768
        //
        // Other frequently used methods include the Mapbox format
        // (red * 256 * 256 + green * 256 + blue) * 0.1 - 10000
        //
        return pixel[0] * 256 + pixel[1] + pixel[2] / 256 - 32768;
      }
      for (pixelY = 0; pixelY <= maxY; ++pixelY) {
        y0 = pixelY === 0 ? 0 : pixelY - 1;
        y1 = pixelY === maxY ? maxY : pixelY + 1;
        for (pixelX = 0; pixelX <= maxX; ++pixelX) {
          x0 = pixelX === 0 ? 0 : pixelX - 1;
          x1 = pixelX === maxX ? maxX : pixelX + 1;

          // determine elevation for (x0, pixelY)
          offset = (pixelY * width + x0) * 4;
          pixel[0] = elevationData[offset];
          pixel[1] = elevationData[offset + 1];
          pixel[2] = elevationData[offset + 2];
          pixel[3] = elevationData[offset + 3];
          z0 = data.vert * calculateElevation(pixel);

          // determine elevation for (x1, pixelY)
          offset = (pixelY * width + x1) * 4;
          pixel[0] = elevationData[offset];
          pixel[1] = elevationData[offset + 1];
          pixel[2] = elevationData[offset + 2];
          pixel[3] = elevationData[offset + 3];
          z1 = data.vert * calculateElevation(pixel);

          dzdx = (z1 - z0) / dp;

          // determine elevation for (pixelX, y0)
          offset = (y0 * width + pixelX) * 4;
          pixel[0] = elevationData[offset];
          pixel[1] = elevationData[offset + 1];
          pixel[2] = elevationData[offset + 2];
          pixel[3] = elevationData[offset + 3];
          z0 = data.vert * calculateElevation(pixel);

          // determine elevation for (pixelX, y1)
          offset = (y1 * width + pixelX) * 4;
          pixel[0] = elevationData[offset];
          pixel[1] = elevationData[offset + 1];
          pixel[2] = elevationData[offset + 2];
          pixel[3] = elevationData[offset + 3];
          z1 = data.vert * calculateElevation(pixel);

          dzdy = (z1 - z0) / dp;

          slope = Math.atan(Math.sqrt(dzdx * dzdx + dzdy * dzdy));

          aspect = Math.atan2(dzdy, -dzdx);
          if (aspect < 0) {
            aspect = halfPi - aspect;
          } else if (aspect > halfPi) {
            aspect = twoPi - aspect + halfPi;
          } else {
            aspect = halfPi - aspect;
          }

          cosIncidence =
            sinSunEl * Math.cos(slope) +
            cosSunEl * Math.sin(slope) * Math.cos(sunAz - aspect);

          offset = (pixelY * width + pixelX) * 4;
          scaled = 255 * cosIncidence;
          shadeData[offset] = scaled;
          shadeData[offset + 1] = scaled;
          shadeData[offset + 2] = scaled;
          shadeData[offset + 3] = elevationData[offset + 3];
        }
      }

      return {
        data: shadeData,
        width,
        height,
        colorSpace: 'srgb',
      };
    }

    const elevation = new ImageTile({
      url: 'https://s3.amazonaws.com/elevation-tiles-prod/terrarium/{z}/{x}/{y}.png',
      maxZoom: 15,
      attributions:
        '<a href="https://github.com/tilezen/joerd/blob/master/docs/attribution.md" target="_blank">Data sources and attribution</a>',
    });

    const raster = new Raster({
      sources: [elevation],
      operationType: 'image',
      operation: shade,
    });

    const projection = new Projection({
      code: 'EPSG:4326',
      units: 'degrees',
      extent: diagExtent,
    });

    const map = new Map({
      target: 'map',
      layers:[
      new TileLayer({
        source: new OSM(),
      }),
      new ImageLayer({
        opacity: 0.3,
        source: raster,
    }),
    ],
      // controls: defaultControls({attribution: false}),
      view: new View({
        projection: 'EPSG:3857',
        center:fromLonLat(txQTH),
        zoom: 10
      }),
    });

/*     const attributions = new Attribution();
    map.addControl(attributions);
      document.querySelector('.ol-attribution').innerHTML = '&copy; <a href="https://www.openstreetmap.org" target="_blank">OpenStreetMap</a>' + ' contributors - Elevation data : Mapzen (EU-DEM layers) - Radio data : Splat! v1.4.3b';
      document.querySelector('.ol-attribution').style.fontFamily = 'Arial, sans-serif';
      document.querySelector('.ol-attribution').style.fontSize = '11px';
      document.querySelector('.ol-attribution').style.backgroundColor = 'rgba(255, 255, 255, 0.7)';
      document.querySelector('.ol-attribution').style.padding = '2px';
 */
    const adminLayer = new VectorLayer({
      source: new VectorSource({
        url: 'geojson/departements-5m.geojson',
        format: new GeoJSON(),
      }),
      style: {
        'fill-color': 'none',
        'stroke-color': '#FFF',
      'stroke-width': 2.0,
      },
    });
    map.addLayer(adminLayer);


    var imgtopo = new ImageLayer({
      source: new Static({
        attributions: ' - Radio data generated by Splat! v1.4.3b',
        url: diagFile,
        projection: projection,
        imageSize: [diagHeight,diagWidth],
        imageExtent: diagExtent,
      }),
      opacity: 0.5,
    });

    map.addLayer(imgtopo);

    var insertLegend = function(options) {
      var ck = document.getElementById('legend');
      ck.className = 'ol-unselectable ol-control';
      ck.style.backgroundColor = "none";
      ck.innerHTML = "<img src='" + ckFile + "' alt='legend not available'>";
    }
  
    insertLegend();

    var insertContents = function(options) {
      let content
      var target = document.getElementById('abstract_content');
      content = "Frequency : " + txFrequency + " MHz</br>";
      content += "ERP : " + txERP + " watts</br>";
      content += "Latitude : " + txQTH[1].toFixed(5) + "°</br>";
      content += "Longitude : " + txQTH[0].toFixed(5) + "°</br>";
      target.innerHTML = content;
    }
  
    insertContents();
	
	var insertTitle = function(options) {
      let title
      var target = document.getElementById('abstract_title');
      title = "TX : " + transmitter;
      target.innerHTML = title;
    }
  
    insertTitle();

    // Add some controls to modify the operation parameters

    const controlIds = ['vert', 'sunEl', 'sunAz'];
    const controls = {};
    controlIds.forEach(function (id) {
      const control = document.getElementById(id);
      const output = document.getElementById(id + 'Out');
      control.addEventListener('input', function () {
        output.innerText = control.value;
        raster.changed();
      });
      output.innerText = control.value;
      controls[id] = control;
    });

    raster.on('beforeoperations', function (event) {
      // the event.data object will be passed to operations
      const data = event.data;
      data.resolution = event.resolution;
      for (const id in controls) {
        data[id] = Number(controls[id].value);
      }
    });



    const diag = document.getElementById('diag');
    const diagOut = document.getElementById('diagOut');

    diagOut.innerText = diag.value;
    diag.addEventListener('input', function() {
      const opacityValue = parseFloat(this.value);
      imgtopo.setOpacity(opacityValue/100);
      diagOut.innerText = opacityValue;
    });

    var markers = new VectorLayer({
      source: new VectorSource(),
      style: new Style({
      image: new Icon({
        scale: 0.4,
        anchor: [0.5, 1],
        src: 'icons/antenne4.png'
      })
      })
    });
    map.addLayer(markers);

    var marker = new Feature(new Point(fromLonLat(txQTH)));
    markers.getSource().addFeature(marker);






})();



